import { css } from "@emotion/react";
import Grid from "@mui/material/Grid";

import DeviceStatus from "./DeviceStatus";
import FirmwareConfig, { FIRMWARE_CONFIG_TYPES } from "./FirmwareConfig";
import ImportedActivated, {
    IMPORTED_ACTIVATED_TYPES
} from "./ImportedActivated";
import Tasks from "./Tasks";
import { LeftSideProps } from "./types";

const LeftSide = ({ ref }: LeftSideProps) => {
    return (
        <div
            ref={ref}
            css={css({
                "& > div + div": {
                    marginTop: "16px"
                }
            })}
        >
            <Grid container spacing={2}>
                <Grid size={{ xs0: 12, lg: 6 }}>
                    <DeviceStatus />
                </Grid>

                <Grid size={{ xs0: 12, lg: 3 }}>
                    <ImportedActivated
                        type={IMPORTED_ACTIVATED_TYPES.Imported}
                    />
                </Grid>

                <Grid size={{ xs0: 12, lg: 3 }}>
                    <ImportedActivated
                        type={IMPORTED_ACTIVATED_TYPES.Activated}
                    />
                </Grid>
            </Grid>

            <Tasks />

            <Grid container spacing={2}>
                <Grid size={{ xs0: 12, lg: 6 }}>
                    <FirmwareConfig
                        type={FIRMWARE_CONFIG_TYPES.FirmwareVersions}
                    />
                </Grid>

                <Grid size={{ xs0: 12, lg: 6 }}>
                    <FirmwareConfig
                        type={FIRMWARE_CONFIG_TYPES.Configurations}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default LeftSide;
